export default __webpack_public_path__ + "static/Years2006-36da67adabda4afffbb63a95d0de30a6.jpeg";